

export const header = [
  {
    id: 1,
    name: 'Proporty',
    position: 'left',
    width: {
      desktop: 145,
      tablet: 145,
      mobile: 145
    }
  },
  {
    id: 2,
    name: "Description",
    position: 'left',
    width: {
      desktop: 'auto',
      tablet: 'auto',
      mobile: 'atuo'
    }
  },
  {
    id: 3,
    name: 'Type',
    position: 'left',
    width: {
      desktop: 175,
      tablet: 175,
      mobile: 175
    }
  },
  {
    id: 4,
    name: 'Default',
    position: 'left',
    width: {
      desktop: 100,
      tablet: 100,
      mobile: 100
    }
  },
  {
    id: 5,
    name: 'Version',
    position: 'left',
    width: {
      desktop: 80,
      tablet: 80,
      mobile: 80
    },
    color: '#00B533'
  },
]

export const data = [
  {
    id: 1,
    prop: "block",
    desc: 'Option to fit button width to its parent width	',
    type: 'boolean',
    default: 'false',
    version: '1v'
  },
  {
    id: 2,
    prop: "block",
    desc: 'Option to fit button width to its parent width	',
    type: 'boolean',
    default: 'false',
    version: '1v'
  }, {
    id: 3,
    prop: "block",
    desc: 'Option to fit button width to its parent width	',
    type: 'boolean',
    default: 'false',
    version: '1v'
  }, {
    id: 4,
    prop: "block",
    desc: 'Option to fit button width to its parent width	',
    type: 'boolean',
    default: 'false',
    version: '1v'
  },
]